import { makeStyles } from "tss-react/mui";

import { Box, BoxProps, Theme, Typography } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
    panel: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: theme.spacing(2, 3, 2, 3),
        borderRadius: theme.spacing(2),
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        backgroundColor: theme.palette.emteria.background.paper,
        boxSizing: "border-box",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minHeight: 40,
    },
    title: {
        minWidth: 0,
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        flexShrink: 0,
    },
    body: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        gap: theme.spacing(1.5),
    },
    footerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        marginTop: theme.spacing(4),
        minHeight: 40,
    },
}));

type SectionPanelProps = {
    title?: React.ReactNode;
    headerActions?: React.ReactNode;
    actions?: React.ReactNode;
    actionsPlacement?: "header" | "footer";
    children: React.ReactNode;
} & Omit<BoxProps, "title" | "children">;

export function SectionPanel(props: SectionPanelProps) {
    const { title, headerActions, actions, actionsPlacement = "footer", children, className, ...rest } = props;
    const { classes, cx } = useStyles();
    const resolvedHeaderActions = headerActions ?? (actionsPlacement === "header" ? actions : null);
    const resolvedFooterActions = actionsPlacement === "footer" ? actions : null;

    return (
        <Box className={cx(classes.panel, className)} {...rest}>
            {title || resolvedHeaderActions ? (
                <Box className={classes.header}>
                    {title ? (
                        <Typography variant="subtitle1" fontWeight="bold" className={classes.title} component="div">
                            {title}
                        </Typography>
                    ) : (
                        <span />
                    )}
                    {resolvedHeaderActions ? <Box className={classes.headerActions}>{resolvedHeaderActions}</Box> : null}
                </Box>
            ) : null}
            <Box className={classes.body}>{children}</Box>
            {resolvedFooterActions ? <Box className={classes.footerActions}>{resolvedFooterActions}</Box> : null}
        </Box>
    );
}
